(function() {
  const STORAGE_KEY = 'bm_preferred_store';

  function getSavedStore() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  }

  function updateStorePickupCard(storePickupCard, store) {
    if (!storePickupCard || !store) return;
    const cardTitle = storePickupCard.querySelector('.card-title');
    if (cardTitle && store.locationName) {
      cardTitle.textContent = store.locationName;
    }
    storePickupCard.dataset.selectedStoreId = store.locationId || '';
    storePickupCard.dataset.selectedStoreName = store.locationName || '';
  }

  function applyStoreName(store) {
    if (!store) return;
    document.querySelectorAll('#store-pickup-card').forEach(function(card) {
      updateStorePickupCard(card, store);
    });
  }

  function openStoreDrawer() {
    if (window.storeSelector && typeof window.storeSelector.openDrawer === 'function') {
      window.storeSelector.openDrawer();
      return;
    }
    const drawer = document.getElementById('StoreSelectorDrawer');
    const overlay = document.getElementById('StoreSelectorOverlay');
    if (drawer && overlay) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  window.initHowToGetIt = function(root) {
    root = root || document;
    const containers = root.querySelectorAll('.how-get-it');

    containers.forEach(function(container) {
      if (container.dataset.htgInitialized === 'true') return;
      container.dataset.htgInitialized = 'true';

      const storePickupCard = container.querySelector('#store-pickup-card');
      const changeStoreLink = container.querySelector('.change-store-link');

      const savedStore = getSavedStore();
      if (savedStore) {
        updateStorePickupCard(storePickupCard, savedStore);
      }

      if (changeStoreLink) {
        changeStoreLink.addEventListener('click', function(event) {
          event.preventDefault();
          openStoreDrawer();
        });
      }

      if (storePickupCard) {
        storePickupCard.addEventListener('click', function(event) {
          if (event.target.tagName === 'A') return;
          openStoreDrawer();
        });
      }
    });
  };

  document.addEventListener('store:selected', function(event) {
    const store = event.detail && event.detail.store;
    if (!store) return;
    applyStoreName(store);
  });

  // Watch for outerHTML replacements of the HOW TO GET IT block caused by
  // variant swaps. global.js replaces .product-block-content-X.variant-changed-update
  // blocks via outerHTML — this destroys the JS-applied store name and event listeners.
  // MutationObserver fires the instant the new node lands in the DOM so no setTimeout
  // is needed, making this bulletproof regardless of swap timing.
  function watchPickupCard() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!node.querySelector) return;

          // Check if added node IS or CONTAINS #store-pickup-card
          var card = node.id === 'store-pickup-card'
            ? node
            : node.querySelector('#store-pickup-card');

          if (!card) return;

          // Re-read store from localStorage at the moment of swap
          // so we always use the latest saved value
          var freshStore = getSavedStore();
          if (freshStore) {
            updateStorePickupCard(card, freshStore);
          }

          // Reset initialized flag and re-bind click handlers on the new DOM nodes
          document.querySelectorAll('.how-get-it').forEach(function(container) {
            delete container.dataset.htgInitialized;
          });
          window.initHowToGetIt();
        });
      });
    });

    // Observe document.body with subtree:true so we catch outerHTML swaps
    // at any depth — the HOW TO GET IT block can be nested inside multiple
    // wrappers (.product-info-description-content, .product-block-content-X etc.)
    // and the exact parent varies per theme config. Observing body is safe
    // here because the callback only acts when #store-pickup-card appears.
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.initHowToGetIt();
      watchPickupCard();
    });
  } else {
    window.initHowToGetIt();
    watchPickupCard();
  }
})();